/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjEyIDEyLjdMMSA3LjU4TDEuNyA2Ljg3TDYuMTIgMTEuMjhMMTQuNCAzTDE1LjEgMy43MUw2LjEyIDEyLjdaIiBmaWxsPSJpbmhlcml0Ii8+";